export default "__VITE_ASSET__DM$zns4h__"